import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./CSS/ContactUs.css";

const ContactUs = () => {
  const form = useRef();
  const [loading, setLoading] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        (result) => {
          console.log("EmailJS Success:", result);
          alert("✅ Message sent successfully!");
          form.current.reset();
          setLoading(false);
        },
        (error) => {
          console.error("EmailJS Full Error:", error);
          alert("❌ Message not sent. Check console for details.");
          setLoading(false);
        }
      );
  };

  return (
    <div className="contact-container">
      <h1>Contact Us</h1>

      <div className="contact-info">
        <div className="contact-item">
          <span>Email:</span> info@priimecosmo.com
        </div>
        <div className="contact-item">
          <span>Phone:</span> +44 7759 818509
        </div>
        <div className="contact-item">
          <span>Address:</span> UK: 45 Parkdale Road, NG3 7GL Nottingham
        </div>
      </div>

      {/* Contact Form */}
      <form ref={form} onSubmit={sendEmail} className="contact-form">
        {/* 🔹 Hidden fields for EmailJS template */}
        <input type="hidden" name="from_name" value="Prime Cosmo Website" />
        <input type="hidden" name="reply_to" value="" />

        <div className="input-group">
          <label>Your Name</label>
          <input type="text" name="name" required />
        </div>

        <div className="input-group">
          <label>Your Email</label>
          <input type="email" name="email" required />
        </div>

        <div className="input-group">
          <label>Your Message</label>
          <textarea name="message" rows="5" required />
        </div>

        <button type="submit" disabled={loading}>
          {loading ? "Sending..." : "Send Message"}
        </button>
      </form>
    </div>
  );
};

export default ContactUs;
